/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { v4 as uuid } from "uuid";
import Image from "../Image";
import InputContainer from "../InputContainer";
import FileUploadBase from "./../FileUploadBase";
import ImageFileUploadInputModel from "./ImageFileUploadInputModel";
import ImageFileUploadInputProps from "./ImageFileUploadInputProps";
import { erstelleImgSrc } from "./utils";
import "./ImageFileUploadInput.scss";

export default function ImageFileUploadInput(props: ImageFileUploadInputProps) {
    const vm = new ImageFileUploadInputModel(props);

    const data = props.value[0]?.data;
    const contentType = props.value[0]?.contentType;
    const imgSrc = React.useMemo(() => {
        if (data && contentType) {
            return erstelleImgSrc(contentType, data);
        }

        return "";
    }, [data, contentType]);

    return (
        <>
            <InputContainer
                fullWidth
                errors={vm.state.errors}
                errorResetFlag={vm.state.errorResetFlag}
                readonly={Boolean(props.readonly)}
                required={Boolean(props.required)}
                formControlClassName="lan-imagefileuploadinput__formcontrol"
                caption={props.caption}
                typBezeichnung={props.typBezeichnung}
                feldBezeichnung={props.feldBezeichnung}
                inputLabelProps={ { className: "lan-imagefileuploadinput__label" } }
                tooltip={props.tooltip}
                ignoreTooltip={props.ignoreTooltip}
            >
                <div className={"lan-imagefileuploadinput__imagefileuploadercontainer"}>
                    <div className={"lan-imagefileuploadinput__imagecontainer"}>
                        {imgSrc && (
                            <Image
                                key={uuid()}
                                background={props.previewBackgroundColor}
                                alternativ={props.altImage}
                                source={imgSrc}
                                quelle={props.quelle}
                            />
                        )}
                    </div>
                    <div className={"lan-imagefileuploadinput__fileuploadercontainer"}>
                        <FileUploadBase
                            allowedFileExtensions={props.allowedFileExtensions}
                            maxFileSize={props.maxFileSize}
                            maxFiles={props.numberFiles}
                            value={props.value}
                            onChange={(dateien) => vm.aendern(dateien)}
                            onValidationError={(message) => vm.fehlerSetzen(message)}
                            readonly={props.readonly}
                            hideChips={props.hideChips}
                        />
                    </div>
                </div>
            </InputContainer>
        </>
    );
}